<template>
    <div>
        <!-- 工具栏 -->
        <ul class="nav">
            <li @click.stop="showResourcesManager = !showResourcesManager" :class="{ 'active': showResourcesManager }" title="资源管理"><i class="iconfont icontuceng"></i></li>
            <li @click.stop="toggleSelector" :class="{ 'active': enableSelector }" title="选择"><i class="iconfont iconxuanze"></i></li>
            <li @click.stop="toggleViewSetting" :class="{ 'active': showViewSetting }" title="默认视角">
                <i class="iconfont iconmorenshijiao"></i>
                <div class="view_menu" v-show="showViewSetting">
                    <p @click.stop="setDefaultView"> <i class="iconfont iconshezhi"></i> 设置默认视角</p>
                    <p @click.stop="getDefaultView"> <i class="iconfont iconqianwang"></i> 回到默认视角</p>
                </div>
            </li>
            <li @click.stop="setBillboard" :class="{ 'active': activeHotSpot}" title="热点"><i class="iconfont iconredian"></i></li>
            <li class="separator"></li>
            <li title="复制" @click.stop="copy" :class="selectedNum == 1 ? 'enable' : 'disable'"><i class="iconfont iconfuzhi1"></i></li>
            <li title="镜像" @click.stop="showMirror = !showMirror" :class="selectedNum == 1 ? 'enable' : 'disable'">
                <i class="iconfont iconjingxiang_duoge"></i>
                <div class="view_menu view_menu_1" v-show="showMirror">
                    <p @click.stop="mirror('x')"> <i class="iconfont iconjuli"></i> x</p>
                    <p @click.stop="mirror('y')"> <i class="iconfont icongaodu"></i> y</p>
                    <p @click.stop="mirror('z')"> <i class="iconfont iconmianji"></i> z</p>
                </div>
            </li>
            <li @click.stop="combine" :class="selectedNum > 1 ? 'enable' : 'disable'" title="分组"><i class="iconfont iconfenzu"></i></li>
            <li @click.stop="explode" :class="selectedNum == 1 ? 'enable' : 'disable'" title="拆分"><i class="iconfont iconjiechufenzu"></i></li>
        </ul>

        <!-- 右键菜单 -->
        <div v-show="menuStat.visiable" class="mouse_menu_container" ref="mouseMenu" :style="{ left: menuStat.x + 'px', top: menuStat.y + 'px' }">
            <ul class="mouse_menu" :class="{ show: menuStat.show }">
                <li @click.stop="deleteModel" title="删除"><i class="iconfont iconshanchu"></i></li>
                <li @click.stop="setBillboard" title="标注"><i class="iconfont iconxinxipai"></i></li>
            </ul>
        </div>

        <!-- 资源管理器 -->
        <resource-manager :visible="showResourcesManager" @hide="showResourcesManager = !showResourcesManager"></resource-manager>

    </div>
</template>

<script>
import _ from 'lodash'
import ResourceManager from './ResourcesManager.vue'
import BusEvent from '@/busEvent'

import uuid from 'uuidjs'

export default {

    components: {
        ResourceManager
    },

    props: {

    },

    data() {
        return {
            enableSelector: false,
            showResourcesManager: false,
            showViewSetting: false,
            activeHotSpot: false,
            selectedNum: 0,
            showMirror: false,
            menuStat: {
                x: 0, 
                y: 0, 
                visiable: false,
                show: false
            },
        }
    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    watch: {
        'menuStat.visiable': function( val ){
            this.viewer.controls.enabled = !val
            // this.modelInfo.visiable = false
            setTimeout(() => {
                this.menuStat.show = val
            }, 100)
        },
    },

    mounted(){
        this.init()
    },

    beforeDestroy(){
        document.removeEventListener( 'keydown', this.deleteHandler )
        this.viewer.container.removeEventListener( 'mousedown', this.clickHandler )
    },

    methods: {

        init(){
            this.$bus.$on( BusEvent.ToolChange, this.onButtonChange.bind(this) )
            this.$bus.$on( BusEvent.SelectedChange, this.onSelectedChange.bind(this) )

            //监听键盘删除/查找键
            this.deleteHandler = this.keydownHandler.bind(this)
            document.addEventListener( 'keydown', this.deleteHandler )

            //鼠标左键单击任意隐藏菜单
            this.clickHandler = (() => this.menuStat.visiable = false).bind(this)
            this.viewer.container.addEventListener('mousedown', this.clickHandler)

            this.toggleSelector()
        },

        toggleSelector(){
            this.$bus.$emit( BusEvent.ToolChange )
            this.enableSelector = true
            this.viewer.enableTransform = true
            this.viewer.transform.setTarget( null )
            this.viewer.transform.setMode( 'translate' )
            this.viewer.operator.enablePointSelector = true
            this.viewer.operator.pointSelectorHandler = this.onSelectedHandler.bind(this)
        },

        onSelectedHandler( intersect, event ){
            this.menuStat.visiable = false
            this.selectedNum = this.viewer.operator.selectedObject.length
            if( !intersect || this.viewer.operator.selectedObject.length != 1 ){
                this.viewer.transform.setTarget( null )
                return
            }
            if( intersect && event ){
                this.menuStat.visiable = true
                this.menuStat.x = event.clientX - 80
                this.menuStat.y = document.body.offsetHeight - event.clientY < 100 ? event.clientY - 240 : event.clientY - 80
            }
            this.showResourcesManager = true
            this.$bus.$emit( BusEvent.SelectedChange )
        },

        /**
         * 选中模型事件
         */
        onSelectedChange(){
            if( this.viewer.operator.selectedObject.length === 1 ){
                this.viewer.enableTransform = true
                this.enableSelector = true
                this.viewer.transform.setTarget( this.viewer.operator.selectedObject[0] )
                this.viewer.transform.setMode( 'translate' )
            }
        },

        /**
         * 菜单切换重置功能
         */
        onButtonChange(){
            this.viewer.operator.selectedObject = []
            this.viewer.enablePointSelector = false
            this.showResourcesManager = false
        },

        toggleViewSetting(){
            this.$bus.$emit( BusEvent.ToolChange )
            this.showViewSetting = !this.showViewSetting 
        },

        setDefaultView(){
            this.viewer.cameraData = this.viewer.controls.getView()
            this.$message.success('设置视角成功')
            this.showViewSetting = false
        },

        getDefaultView(){
            this.viewer.controls.flyTo( this.viewer.cameraData )
            this.showViewSetting = false
        },

        /**
         * 开启放置标注
         */
        setBillboard(){
            this.$notify({
                title: '提示',
                type: 'success',
                position: 'bottom-left',
                message: '单击模型任意位置，添加标注',
                duration: 3000
            })
            this.showResourcesManager = false
            this.menuStat.visiable = false
            this.viewer.transform.setTarget( null )
            this.viewer.operator.pointSelectorHandler = _selectedHandler.bind(this)
            this.viewer.operator.disabledDrag = true
            function _selectedHandler( intersect, event ){
                if( intersect == this.viewer.selectedObject[0] ){
                    this.viewer.selectedObject = []
                    this.$parent.$refs.billboard.init( event )
                }
                this.viewer.operator.disabledDrag = false
                this.viewer.operator.pointSelectorHandler = this.onSelectedHandler.bind(this)
            }
        },

        /**
         * 复制模型
         */
        copy(){
            const selectedObject = this.viewer.selectedObject[0]
            if( !selectedObject ){
                this.$message.warning('请选中模型')
                return
            }
            if( !selectedObject.isSceneModel || selectedObject.isGroup ){
                this.$message.warning('仅支持单个模型复制')
                return 
            }
            var mesh = selectedObject.clone()
            mesh.mid = uuid.genV4().toString()
            mesh.modelName = selectedObject.modelName
            mesh.isSceneModel = true
            mesh.path = selectedObject.path
            mesh.sourceId = selectedObject.sourceId
            this.viewer.addModel( mesh )
            viewer.selectedObject = [ mesh ]
            viewer.transform.setTarget( mesh )
            this.$bus.$emit( BusEvent.SceneChange )
            this.$message.success( '复制模型成功' )
        },

        /**
         * 打组
         */
        combine(){
            if( this.viewer.selectedObject.length > 1 ){
                this.$prompt('请输入组名', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^(.|\n){1,6}$/,
                    inputErrorMessage: '组名为1到6个字符组成',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    closeOnHashChange: false
                }).then(({ value }) => {
                    this.viewer.selectedObject = [ this.viewer.resourceManager.combine( this.viewer.selectedObject, value ) ]
                    this.$bus.$emit( BusEvent.SceneChange )
                }).catch()
            } 
        },

        /**
         * 分拆
         */
        explode(){
            if( this.viewer.selectedObject.length == 1 ){
                let group = this.viewer.selectedObject[0]
                this.viewer.selectedObject = []
                this.viewer.transform.setTarget( null )
                this.viewer.resourceManager.explode( group )
                this.$bus.$emit( BusEvent.SceneChange )
            }
        },

        /**
         * 添加镜像物体
         */
        mirror(axis){
            this.showMirror = false
            const selectedObject = this.viewer.selectedObject[0]
            if( !selectedObject ){
                this.$message.warning('请选中模型')
                return
            }
            if( !selectedObject.isSceneModel || selectedObject.isGroup ){
                this.$message.warning('仅支持单个模型镜像操作')
                return 
            }
            var mesh = selectedObject.clone()
            mesh.mid = uuid.genV4().toString()
            mesh.modelName = selectedObject.modelName
            mesh.isSceneModel = true
            mesh.path = selectedObject.path
            mesh.sourceId = selectedObject.sourceId
            switch (axis) {
                case 'x':
                    mesh.scale.x = -mesh.scale.x
                    break;
                case 'y':
                    mesh.scale.y = -mesh.scale.y
                    break;
                case 'z':
                    mesh.scale.z = -mesh.scale.z
                    break;
                default:
                    break;
            }
            this.viewer.addModel( mesh )
            viewer.selectedObject = [ mesh ]
            viewer.transform.setTarget( mesh )
            this.$message.success( '模型镜像成功' )
            this.$bus.$emit( BusEvent.SceneChange )
            this.$bus.$emit( BusEvent.SelectedChange )
        },
        /**
         * 删除模型
         */
        deleteModel(){
            this.viewer.transform.setTarget( null )
            let selectedObjects = this.viewer.selectedObject
            if( Array.isArray( selectedObjects ) && selectedObjects.length > 0 ){
                selectedObjects.map(obj => {
                    if( obj.isGroup ){
                        obj.traverse( mesh => {
                            if( mesh.mid ){
                                this.viewer.hotSpotManager.defaultLayer.spots.map(item => {
                                    if( item.userData.mid == mesh.mid ){
                                        this.viewer.hotSpotManager.defaultLayer.remove(item)
                                    }
                                })
                            }
                        })
                    }else{
                        this.viewer.hotSpotManager.defaultLayer.spots.map(item => {
                            if( item.userData.mid == obj.mid ){
                                this.viewer.hotSpotManager.defaultLayer.remove(item)
                            }
                        })
                    }
                    this.viewer.removeModel( obj )
                    this.$bus.$emit( BusEvent.SceneChange )
                })
            }
            this.viewer.selectedObject = []
            this.menuStat.visiable = false
            this.transformMode = false
        },

        keydownHandler(){
            
        }
    }
}

</script>

<style lang="scss" scoped> @import './style.scss';

</style>
<style lang="scss">
.my-autocomplete{ couter-reset: count -1; counter-increment: count 0; width:350px !important; left: 30px !important; }
.my-autocomplete li{line-height: 44px !important;}
.my-autocomplete [role=option]::before{ 
    content: counter(count); font-size: 10px; counter-increment: count; display: inline-block; width: 24px; height: 30px; line-height: 30px; position: relative; top: -2px; background: url('~@/assets/img/location.png'); background-repeat: no-repeat; background-position: center; color: #FFF; text-align: center; margin-right: 5px;    background-size: contain;
}
.my-autocomplete li:hover{
    &::before{ 
        content: counter(count); counter-increment: count; display: inline-block; width: 24px; height: 30px; line-height: 30px; position: relative; top: -2px; background: url('~@/assets/img/location_1.png'); background-repeat: no-repeat; background-position: center; color: #FFF; text-align: center; margin-right: 5px;    background-size: contain;
    }
}
</style>